import React, { useMemo } from "react";
import {
  AppBar,
  Avatar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Paper,
  Button,
  Tooltip,
  Select,
  MenuItem,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import BarChartIcon from "@mui/icons-material/BarChart";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./telecalling.css";

export const TopBar = ({ onRefresh, dataType = "general", onDataTypeChange }) => (
  <AppBar position="sticky" elevation={0} className="topBar">
    <Toolbar className="toolbar" style={{ justifyContent: "space-between" }}>
      <Typography variant="h6" fontWeight="700">Telecalling Workspace</Typography>

      <Box
        className="statsBox"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2.5,
          paddingRight: 0,
        }}
      >
        <Select
          value={dataType}
          onChange={(e) => onDataTypeChange(e.target.value)}
          size="small"
          sx={{ backgroundColor: "#fff", borderRadius: 1, minWidth: 160 }}
        >
          <MenuItem value="general">General Data</MenuItem>
          <MenuItem value="eligibility">Eligibility Check</MenuItem>
          <MenuItem value="callback">Callback Queue</MenuItem>
          <MenuItem value="search">Search Data</MenuItem>
        </Select>

        <Tooltip title="My Stats (coming soon)">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              size="small"
              sx={{ padding: "4px", minWidth: "auto" }}
            >
              <BarChartIcon fontSize="small" />
            </IconButton>
          </Box>
        </Tooltip>

        <Tooltip title="Fetch next eligible lead">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              size="small"
              onClick={onRefresh}
              sx={{ padding: "4px", minWidth: "auto" }}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Box>
        </Tooltip>
      </Box>
    </Toolbar>
  </AppBar>
);

export const LeadCard = ({ lead }) => {
  const initials = useMemo(() => {
    const n = lead?.name || "";
    return n.split(" ").slice(0, 2).map(s => s[0]).join("") || "?";
  }, [lead]);

  const whatsappHref = useMemo(() => {
    const msisdn = (lead?.mobile_number || "").replace(/\D/g, "");
    const withCode = msisdn.startsWith("91") ? msisdn : `91${msisdn}`;
    return `https://wa.me/${withCode}`;
  }, [lead]);

  return (
    <Paper elevation={3} className="leadCard">
      <Box className="leadHeader">
        <Avatar className="avatar">{initials}</Avatar>
        <Box className="leadInfo">
          <Typography variant="h6" fontWeight="700" noWrap>
            {lead?.name || "—"}
          </Typography>
        </Box>
        <Box className="actionButtons">
          <Tooltip title="Call">
            <span>
              <Button
                startIcon={<PhoneIcon />}
                variant="contained"
                href={`tel:${lead?.mobile_number || ""}`}
                className="callButton"
              >
                {lead?.mobile_number || "—"}
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="Open WhatsApp">
            <span>
              <Button
                startIcon={<WhatsAppIcon />}
                variant="outlined"
                href={whatsappHref}
                target="_blank"
                rel="noreferrer"
                className="whatsappButton"
              >
                WhatsApp <OpenInNewIcon fontSize="small" style={{ marginLeft: 4 }} />
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>    </Paper>
  );
};